<template>
  <div>
  <b-row class="justify-content-center" style="width: 101.1%; height: 50px; overflow: hidden; background: white;">
      <div class="col-md-12">
     <a href="/">
      <img :src="logo" style="width: 190px; padding: 10px 20px;">
    </a>
      </div>
    </b-row>
    <div
      class="app flex-row align-items-center"
      v-bind:style="{
        'background-image': 'url(' + bg_img + ') !important',
        'min-height': '92vh',
        'background-repeat': 'repeat-x !important',
      }"
    >
      <div class="container">
        <b-row class="justify-content-center">
          <b-col md="8">
            <b-card-group>
              <b-card no-body class="p-4">
                <b-card-body>
                  <div class="row">
                    <div class="col-md-12" v-if="errorMessage.verifyemail">
                      <div :class="verfiy_color" style="text-align: center">
                        {{ errorMessage.verifyemail }}
                      </div>
                    </div>
                  </div>
                  <h1>verification</h1>
                  <p class="text-muted">Enter your Number</p>
                  <div
                    v-if="hasErrors.message"
                    style="
                      color: red;
                      margin-left: 47px;
                      font-size: 11px;
                      font-weight: bold;
                    "
                    class="help-block"
                    v-html="errorMessage.message"
                  >
                    <!-- <strong>{{errorMessage.message}}</strong> -->
                  </div>
                  <div
                    v-if="hasErrors.both"
                    style="color: red; margin-left: 47px; font-size: 11px"
                    class="help-block"
                  >
                    <strong>{{ errorMessage.both }}</strong>
                  </div>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend
                      ><b-input-group-text
                        ><i class="fa fa-phone"></i></b-input-group-text
                    ></b-input-group-prepend>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Phone"
                      name="both"
                      id="both"
                      v-model="loginData.both"
                      required
                    />
                  </b-input-group>

                  <div
                    v-if="hasErrors.password"
                    style="color: red; margin-left: 47px; font-size: 12px"
                    class="help-block"
                  >
                    <strong>{{ errorMessage.password }}</strong>
                  </div>
                  <b-input-group v-if="Verifiednumber" class="mb-3">
                    <b-input-group-prepend
                      ><b-input-group-text
                        ><i class="icon-lock"></i></b-input-group-text
                    ></b-input-group-prepend>
                    <input
                      type="password"
                      class="form-control"
                      placeholder="Password"
                      v-model="loginData.password"
                      id="password"
                      name="password"
                      required
                    />
                  </b-input-group>
                  <b-col cols="12" class="text-right" v-if="Verifiednumber">
                    <b-button
                      type="button"
                      variant="link"
                      class="px-0"
                      @click="GetOTPonPhone()"
                      >Forgot password?</b-button
                    >
                  </b-col>
                  <!-- <b-row>
                   <b-col cols="1" class="text-right">
                   <b-button type="button" variant="link" class="px-0" @click="resetmodel" >Login With OTP</b-button>
                  </b-col>
                 </b-row> -->
                  <b-row>
                    <b-col cols="12" v-if="Continueview">
                      <b-button
                        type="button"
                        variant="primary"
                        class="px-4"
                        @click.prevent="Verifythenumber()"
                        >Verify</b-button
                      >
                    </b-col>
                    <b-col cols="12" v-if="Verifiednumber">
                      <b-button
                        type="button"
                        variant="primary"
                        class="px-4"
                        @click.prevent="loginPost()"
                        >Login</b-button
                      >
                    </b-col>
                    <!-- <b-col cols="6" class="text-right">
                   <b-button type="button" variant="link" class="px-0" @click="resetmodel" >Forgot password?</b-button>
                  </b-col> -->
                  </b-row>
                  <b-input-group v-if="Verifiednumber" class="mb-3">
                    <div class="form-check form-check-inline mr-1">
                      <input
                        class="form-check-input"
                        id="check1"
                        type="checkbox"
                        v-model="remember"
                      />
                      <label class="form-check-label" for="check1"
                        >Remember</label
                      >
                    </div>
                  </b-input-group>

                  <!-- <p  v-if="Verifiednumber">----------------- OR ----------------------</p> -->

                  <b-row>
                    <b-col cols="12" v-if="NewOTPGenerator">
                      <b-button
                        type="button"
                        variant="primary"
                        class="px-4"
                        @click.prevent="GetOTPonPhone()"
                        >Get otp on phone</b-button
                      >
                    </b-col>
                    <!-- <b-col cols="6" class="text-right">
                   <b-button type="button" variant="link" class="px-0" @click="resetmodel" >Forgot password?</b-button>
                  </b-col> -->
                  </b-row>
                </b-card-body>
              </b-card>
            </b-card-group>
          </b-col>
        </b-row>
      </div>
      <b-modal
        title="Forgot Password"
        size="lg"
        class="modal-warning"
        v-model="warningModal"
        hide-footer
        @ok="warningModal = true"
        ok-variant="warning"
      >
        <div class="row">
          <div class="col-md-12" v-if="errorMessage.statusemail">
            <div :class="status_color" style="text-align: center">
              {{ errorMessage.statusemail }}
            </div>
          </div>
        </div>
        <b-row>
          <b-col sm="12">
            <b-form-group>
              <label for="name">Phone</label>
              <b-form-input
                type="text"
                id="name1"
                placeholder="Phone"
                v-model="resetemail"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <!-- warningmodel=true -->
          <b-col sm="3">
            <b-button
              type="button"
              variant="primary"
              @click.prevent="reseturl"
              block
              >Verify</b-button
            >
          </b-col>
        </b-row>
      </b-modal>

      <b-modal
        title="Forgot Password"
        size="lg"
        class="modal-warning"
        hide-footer
        v-model="warningModal1"
        @ok="warningModal1 = true"
        ok-variant="warning"
      >
        <div class="row">
          <div class="col-md-12" v-if="errorMessage.statusemail">
            <div :class="status_color" style="text-align: center">
              {{ errorMessage.statusemail }}
            </div>
          </div>
        </div>
        <b-row>
          <b-col sm="12">
            <b-form-group>
              <label for="name">Token Id</label>
              <b-form-input
                type="text"
                v-model="resettoken"
                placeholder="Otp"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <b-form-group>
              <label for="name">Password</label>
              <b-form-input
                type="text"
                v-model="resetpassword"
                placeholder="Password"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <b-form-group>
              <label for="name">Confirm Password</label>
              <b-form-input
                type="text"
                v-model="resetpasswordconf"
                placeholder="Confirm Password"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col sm="3">
            <b-button @click.prevent="loginPost1" variant="primary" block
              >Verify</b-button
            >
          </b-col>
        </b-row>
      </b-modal>
      <Spinner v-if="loading"></Spinner>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Spinner from "../../spinner.vue";

export default {
  name: "Verification",
  components: {
    Spinner,
  },
  computed: {},
  data() {
    return {
      logo: null,
      bg_img: null,
      remember: 0,
      loading: false,
      status_color: "alert alert-success",
      warningModal: false,
      warningModal1: false,
      resetemail: "",
      resetpassword: "",
      resettoken: "",
      resetpasswordconf: "",
      checkwarningmodel1: "",
      varificationuser: false,
      verfiy_color: "alert alert-success",
      loginData: {
        both: "",
        password: "",
      },
      customertoken: "",
      customerdata: [],
      Verifiednumber: false,
      NewOTPGenerator: false,
      Continueview: true,
      hasErrors: {
        both: false,
        password: false,
        message: false,
      },
      errorMessage: {
        verifyemail: null,
        both: null,
        password: null,
        message: null,
        statusemail: null,
      },
    };
  },
  created() {
    this.logo = this.baseURL2 + "/design/img/logo.png";
    this.bg_img = this.baseURL2 + "/design/img/ban1.jpg";
    var is_remember = this.getCookie("is_remember");
    // var company_id = this.getCookie('company_id')
    var username = this.getCookie("username");

    if (is_remember == "true") {
      this.remember = true;
      this.loginData.both = username;
    }

    this.test();
  },

  methods: {
    getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    test() {
      // console.log(this.$route.query.id)
      if (this.$route.query.id != undefined) {
        this.verfiyemai();
      } else {
        this.$router.push("/verification");
      }
    },

    verfiyemai() {
      var _this = this;
      var submit = 0;
      if (this.$route.query.id != undefined) {
        if (this.$route.query.id.length <= 50) {
          this.$router.push("/verification");
          submit = 1;
        }
        if (submit == 0) {
          this.$http
            .get("/api/users/confirm?uid=" + this.$route.query.id + "")
            .then(function (response) {
              _this.verfiy_color = "alert alert-success";
              _this.errorMessage.verifyemail = "Account Activated Successfully";
              setTimeout(function () {
                _this.verfiy_color = "alert alert-success";
                _this.errorMessage.verifyemail = null;
                _this.$router.push("/verification");
              }, 10000);
            })
            .catch(function (error) {
              _this.verfiy_color = "alert alert-danger";
              _this.errorMessage.verifyemail = "Token Has Been Expired";
              setTimeout(function () {
                _this.verfiy_color = "alert alert-success";
                _this.errorMessage.verifyemail = null;
                _this.$router.push("/verification");
              }, 10000);
            });
        }
      }
    },
    resetmodel() {
      if (this.checkwarningmodel1 != "") {
        if (this.checkwarningmodel1 != "open1") {
          this.warningModal1 = true;
        }
      } else {
        this.warningModal = true;
      }
    },
    reseturl() {
      var _this = this;
      var data = {
        phone: this.resetemail,
      };
      this.$http
        .post("/request-password-reset", data)
        .then(function (response) {
          if (response.status == 200) {
            _this.warningModal = false;
            _this.errorMessage.verifyemail =
              "Please Check Your Email for Password Reset";
            _this.status_color = "alert alert-success";
            setTimeout(function () {
              _this.verfiy_color = "alert alert-success";
              _this.errorMessage.verifyemail = null;
            }, 10000);
          } else {
            _this.errorMessage.statusemail =
              "Please Try Again Or Email Id does Not exists";
            _this.status_color = "alert alert-danger";
          }
        })
        .catch(function (error) {
          _this.errorMessage.statusemail = error.response.data.code;
          _this.status_color = "alert alert-danger";
        });
    },

    loginPost1() {
      var _this = this;
      if (
        this.resetpassword === this.resetpasswordconf &&
        this.resettoken != ""
      ) {
        var data = {
          newPassword: this.resetpassword,
          confirmation: this.resetpasswordconf,
        };
        // console.log(this.resettoken)
        this.$http
          .post(
            "/api/users/reset-password?access_token=" + this.resettoken,
            data
          )
          .then(function (response) {
            _this.errorMessage.statusemail = "Password Reset Successfully";
            _this.status_color = "alert alert-success";
            _this.checkwarningmodel1 = "";
          })
          .catch(function (error) {
            _this.errorMessage.statusemail = "Something Went Wrong :(";
            _this.status_color = "alert alert-danger";
          });
      } else if (this.resetpassword !== this.resetpasswordconf) {
        _this.errorMessage.statusemail = "Password Does Not Match";
        _this.status_color = "alert alert-danger";
      } else {
        _this.errorMessage.statusemail = "Please Provide Token Id ";
        _this.status_color = "alert alert-danger";
      }
    },

    Verifythenumber() {
      var _this = this;
      var vm = this.hasErrors;
      var _vm = this.errorMessage;
      if (this.loginData.both === "" || this.loginData.both === null) {
        vm.both = true;
        _vm.both = "Required Phone Number";
      }
      else if(this.loginData.both.length>10 ||this.loginData.both.length<10){
         vm.both = true
        _vm.both = "Invalid Phone Number"
        return false;
      }
      else {
        this.loading = true;
        var re =
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var number = /^[0-9]{9,14}$/;

        if (number.test(this.loginData.both) === true) {
          var log = {
            phone: this.loginData.both,
          };
        }

        this.$http
          .post("/api/customers/Verifyingphonenumber", log)
          .then(function (response) {
            console.log(response);
            if (response.status === 200) {
              if (response.data == null) {
                vm.both = true;
                _vm.both = "User Not Found";
              } else {
                // if (response.data.txt_pass == null || response.txt_pass == "") {
                //   _this.NewOTPGenerator = true;
                //   _this.Verifiednumber = false;
                //   _this.Continueview = false;
                //   _this.customerdata = response.data;
                // } else {
                //   _this.NewOTPGenerator = false;
                //   _this.Verifiednumber = true;
                //   _this.Continueview = false;
                //   _this.customerdata = response.data;
                // }
                // this.$router.props = [this.customerdata.cust_cmp_phone];
      localStorage.setItem(
        "customerphonenumber",
        JSON.stringify(_this.loginData.both)
      );
                _this.$router.push("/generateotp");
              }

              _this.loading = false;
            } else if (response.data === 401) {
              vm.both = true;
              _vm.both = "Something went wrong";
              _this.loading = false;
            } else {
              _this.loading = false;
            }
          })
          .catch(function (error) {
            console.log("error");
            console.log(error);
            _this.loading = false;
            vm.message = true;
            _vm.message = error.response.data.error.message;
          });
      }
    },

    GetOTPonPhone() {
      this.$router.props = [this.customerdata.cust_cmp_phone];
      localStorage.setItem(
        "customerphonenumber",
        JSON.stringify(this.customerdata.cust_cmp_phone)
      );
      this.$router.push("/generateotp");
     
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/views/goldcustomers/Verification.vue